import { XMarkIcon } from "@heroicons/react/24/outline";

import { Link } from "react-router-dom";

interface ISelectedTagParams {
  tag: string;
}

function SelectedTag(params: ISelectedTagParams) {
  const { tag } = params;
  return (
    <div className="z-50 fixed top-2 w-full flex left-2">
      {tag && tag.length > 0 && tag !== "default" && (
        <div
          className="align-middle py-2 px-2 shadow-md no-underline bg-zinc-800/90 text-white text-sm border-slate-400 btn-primary hover:text-white hover:bg-slate-500 active:shadow-none mr-2"
          style={{
            fontFamily: "Courier Prime",
          }}
        >
          {/* <div className="py-1 px-2 shadow-md no-underline text-lg rounded-full bg-red-700/50 text-white font-sans font-semibold text-sm border-slate-400 btn-primary hover:text-white hover:bg-slate-500 active:shadow-none mr-2"> */}
          <Link to={`/`}>
            <XMarkIcon
              className="float-left dark:text-white h-6 w-6"
            />{" "}
          </Link>
          <span className="align-middle text-base">{tag}</span>
        </div>
      )}
    </div>
  );
}

export default SelectedTag;

